<template>
  <organism-add-service-data
    v-model="serviceDetail"
    @createNewService="onCreateNewService"
  ></organism-add-service-data>
</template>

<script>
import { addService } from "@/api/api-module1"
import OrganismAddServiceData from "@/components/organisms/globalSetting/dataManagement/service/OrganismAddServiceData.vue"
import mixins from "@/mixins"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"

export default {
  name: "AddServiceData",
  components: {
    OrganismAddServiceData,
  },
  mixins: [mixins, mixinsObjectHelper],
  data() {
    return {
      serviceDetail: {
        serviceId: null,
        serviceName: "",
        deprecated: false,
        packages: [],
      },
    }
  },

  methods: {
    async onCreateNewService(serviceDetail) {
      this.showLoading(true)
      await addService(serviceDetail)
        .then(async (response) => {
          if (response) {
            this.toastSuccess("Created New Service Successfully")

            this.$router.push(
              `/global-settings/data-management/service/${response.data}`
            )
          }
        })
        .catch(() => {
          this.toastError("Create New Service Failed")
        })
        .finally(() => this.showLoading(false))
    },
  },
}
</script>

<style lang="scss" scoped></style>
